import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  return (
    <Card className="card">
      <CardMedia component="img" image={product.image} height={250} alt="bag" />
      <CardContent>
        <Typography component="div" gutterBottom>
          {product.name}
        </Typography>
        <Typography component="div" gutterBottom>
          ${product.cost}
        </Typography>
        <Rating
          name="half-rating-read"
          defaultValue={product.rating}
          precision={0.5}
          readOnly
        />
      </CardContent>
      <CardActions style={{ paddingBottom: 20 }}>
        <Button
          variant="contained"
          startIcon={<AddShoppingCartOutlined />}
          fullWidth
          onClick={() => handleAddToCart(product)}
        >
          Add to Cart
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
